
export const AddOrg = () => (
    <svg viewBox="0 0 22 21">
        <path d="M2 0C0.906937 0 0 0.906937 0 2V18H12V16H2V2H12V14H14H15V12H14V10H16V8H14V6H18V11H20V6C20 4.90694 19.0931 4 18 4H14V2C14 0.906937 13.0931 0 12 0H2ZM4 4V6H6V4H4ZM8 4V6H10V4H8ZM4 8V10H6V8H4ZM8 8V10H10V8H8ZM4 12V14H6V12H4ZM8 12V14H10V12H8ZM17 21L17 18.0001L14.0001 18.0001L14.0001 16.0001L17 16.0001L17 13H19L19 16.0002L22 16.0002L22 18.0002L19 18.0002L19 21H17Z" />
    </svg>
);
